import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import bannerImg from '../../assets/images/bann.png';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="vedhyas-hero">

      {/* Cinematic Background */}
      <div className="vedhyas-hero-media">
        <img
          src={bannerImg}
          alt="VEDHYAS Saree Collection"
          className="vedhyas-hero-image"
          loading="eager"
          decoding="async"
        />

        {/* Dark luxury overlay */}
        <div className="vedhyas-hero-overlay" />

        {/* Moving light */}
        <div className="vedhyas-light-sweep" />

        {/* Golden glow */}
        <div className="vedhyas-gold-glow" />
      </div>

      {/* Floating particles */}
      <div className="vedhyas-particles">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>

      {/* Content */}
      <div className="vedhyas-hero-content">

        {/* Small eyebrow */}
        <div className="vedhyas-eyebrow">
          <span className="eyebrow-line" />

          <Sparkles className="eyebrow-icon" />

          <span>THE VEDHYAS EDIT</span>

          <span className="eyebrow-line" />
        </div>

        {/* Heading */}
        <h1 className="vedhyas-hero-title">
          <span className="title-line">
            Weaving Royalty
          </span>

          <span className="title-line title-accent">
            into Every Thread.
          </span>
        </h1>

        {/* Description */}
        <p className="vedhyas-hero-description">
          Timeless sarees, thoughtfully woven for the woman
          who carries tradition with effortless grace.
        </p>

        {/* Gold divider */}
        <div className="vedhyas-divider">
          <span />
          <i />
          <span />
        </div>

        {/* Buttons */}
        <div className="vedhyas-hero-actions">

          <button
            onClick={() => navigate('/catalog')}
            className="vedhyas-primary-btn"
          >
            <span>Explore Collection</span>

            <span className="btn-arrow">
              <ArrowRight />
            </span>
          </button>

          <button
            onClick={() => navigate('/catalog?featured=true')}
            className="vedhyas-secondary-btn"
          >
            Discover the Edit
          </button>

        </div>

      </div>

      {/* Bottom scroll indicator */}
      <div className="vedhyas-scroll-indicator">
        <span>SCROLL TO DISCOVER</span>
        <div className="scroll-line">
          <i />
        </div>
      </div>

      {/* Corner decoration */}
      <div className="hero-corner hero-corner-tl" />
      <div className="hero-corner hero-corner-br" />

    </section>
  );
};

export default HeroSection;